
const festivalDecorationsData = [
  {
    title: "Dussehra",
    image: "/Assets/navaratri.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Halloween",
    image: "/Assets/halloween.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Christmas",
    image: "/Assets/christmas.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "New Year",
    image: "/Assets/new-year.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Republic Day",
    image: "/Assets/RD1.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Diwali",
    image: "/Assets/diwali.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Independence Day",
    image: "/Assets/ID1.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Ganesh Chathurthi",
    image: "/Assets/RD1.webp",
    price: 1999,
    rating: 4,
  }
];

export default festivalDecorationsData;
